<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="toc"><strong>Table of Contents</strong></h1>
<p class="toc0"><a href="#/OEBPS/cvi.htm">Cover</a></p>
<p class="toc0"><a href="#/OEBPS/praise.htm" id="praise">Praise for History of Wolves</a></p>
<p class="toc0"><a href="#/OEBPS/tp.htm">Title Page</a></p>
<p class="toc0"><a href="#/OEBPS/cop.htm">Copyright</a></p>
<p class="toc0"><a href="#/OEBPS/ded.htm">Dedication</a></p>
<p class="toc0"><a href="#/OEBPS/fm.htm">Epigraph</a></p>
<p class="toc1"><a href="#/OEBPS/p01.htm" id="p01">Science</a></p>
<p class="toc"><a href="#/OEBPS/c01.htm" id="c01">Chapter One</a></p>
<p class="toc"><a href="#/OEBPS/c02.htm" id="c02">Chapter Two</a></p>
<p class="toc"><a href="#/OEBPS/c03.htm" id="c03">Chapter Three</a></p>
<p class="toc"><a href="#/OEBPS/c04.htm" id="c04">Chapter Four</a></p>
<p class="toc"><a href="#/OEBPS/c05.htm" id="c05">Chapter Five</a></p>
<p class="toc"><a href="#/OEBPS/c06.htm" id="c06">Chapter Six</a></p>
<p class="toc"><a href="#/OEBPS/c07.htm" id="c07">Chapter Seven</a></p>
<p class="toc"><a href="#/OEBPS/c08.htm" id="c08">Chapter Eight</a></p>
<p class="toc"><a href="#/OEBPS/c09.htm" id="c09">Chapter Nine</a></p>
<p class="toc"><a href="#/OEBPS/c10.htm" id="c10">Chapter Ten</a></p>
<p class="toc"><a href="#/OEBPS/c11.htm" id="c11">Chapter Eleven</a></p>
<p class="toc1"><a href="#/OEBPS/p02.htm" id="p02">Health</a></p>
<p class="toc"><a href="#/OEBPS/c12.htm" id="c12">Chapter Twelve</a></p>
<p class="toc"><a href="#/OEBPS/c13.htm" id="c13">Chapter Thirteen</a></p>
<p class="toc"><a href="#/OEBPS/c14.htm" id="c14">Chapter Fourteen</a></p>
<p class="toc"><a href="#/OEBPS/c15.htm" id="c15">Chapter Fifteen</a></p>
<p class="toc"><a href="#/OEBPS/c16.htm" id="c16">Chapter Sixteen</a></p>
<p class="toc"><a href="#/OEBPS/c17.htm" id="c17">Chapter Seventeen</a></p>
<p class="toc"><a href="#/OEBPS/c18.htm" id="c18">Chapter Eighteen</a></p>
<p class="toc"><a href="#/OEBPS/c19.htm" id="c19">Chapter Nineteen</a></p>
<p class="toc"><a href="#/OEBPS/c20.htm" id="c20">Chapter Twenty</a></p>
<p class="toc"><a href="#/OEBPS/c21.htm" id="c21">Chapter Twenty-One</a></p>
<p class="toc"><a href="#/OEBPS/c22.htm" id="c22">Chapter Twenty-Two</a></p>
<p class="toc0"><a href="#/OEBPS/ack.htm" id="ack">Acknowledgments</a></p>
<p class="toc0"><a href="#/OEBPS/bm2.htm" id="bm2">Stories we Tell when we Won’t see what’s in front of us: Q&amp;A with Emily Fridlund</a></p>
<p class="toc0"><a href="#/OEBPS/back.htm">Back Cover</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2f2d66fc